import { styled } from '@styledComponents';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';
import { Flex } from '@components/Flex';
import { CloudImage } from '@components/CloudImage';
import { GetStartedButton } from '@components/GetStartedButton/GetStartedButton';

export const StyledFlex = styled(Flex)`
  position: relative;
  background-color: #f8e4e2;
  ${themeMediaQuery('sm')} {
    border-radius: 8px 8px 0 0;
    overflow: hidden;
  }
`;

export const TextWrapper = styled(Flex)`
  ${themeMediaQuery('below_sm')} {
    position: absolute;
  }
  ${themeMediaQuery('tablet')} {
    position: initial;
    padding-bottom: 100px;
  }
`;

export const PaymentLogos = styled(Flex)`
  gap: 34px;
  ${themeMediaQuery('sm')} {
    gap: 48px;
  }
`;

export const StyledTextPairing = styled(TextPairing)`
  ${themeMediaQuery('below_sm')} {
    align-items: center;
    text-align: center;
    .text-pairing-title {
      font-size: 40px;
      line-height: 46px;
    }
  }
`;

export const DisplayAboveMobileCloudImage = styled(CloudImage)`
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
  ${themeMediaQuery('tablet')} {
    display: block;
  }
  ${themeMediaQuery('sm')} {
    border-radius: 0 0 8px 8px;
    overflow: hidden;
  }
`;

export const DisplayOnMobileCloudImage = styled(CloudImage)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
  ${themeMediaQuery('tablet')} {
    display: none;
  }
`;

export const StyledGetStartedButton = styled(GetStartedButton)`
  background-color: transparent;
  margin: ${themeSpace(6)} 0;
`;

export const StyledCloudImage = styled(CloudImage)`
  ${themeMediaQuery('below_sm')} {
    width: 26%;
  }
`;
